<template>
  <div class="transactions-table-header">
    <div
      :key="`header-col-${headerCol.id}`"
      v-for="headerCol in headerCols"
      class="transactions-table-header__col"
      :class="[
        ...headerCol.additionalClasses,
        sort.col === headerCol.sortKey ? 'sort-active' : '',
      ]"
      @click="headerCol.hasSort ? setSort(headerCol.sortKey) : () => {}"
    >
      <div
        class="transactions-table-header__col-text"
        v-html="$t(headerCol.title)"
      ></div>
      <div class="transactions-table-header__col-sort" v-if="headerCol.hasSort">
        <traces-sort-button
          :dir="sort.col === headerCol.sortKey ? sort.dir : null"
        ></traces-sort-button>
      </div>
    </div>

    <template v-for="headerCol in headerCols">
      <div v-if="hasFilterInputs" class="transactions-table-header__col-input">
        <template v-if="headerCol.id === 'status'">
          <div class="status-switch">
            <label class="switch">
              <!-- Bind the switch to statusFilter -->
              <input type="checkbox" v-model="statusFilter" />
              <span class="slider round"></span>
            </label>
            <span class="status-text">{{
              statusFilter ? 'активна' : 'не активна'
            }}</span>
          </div>
        </template>

        <template v-else>
          <input
            v-if="headerCol.additionalClasses.includes('filter-type__input')"
            type="text"
            placeholder="Filter..."
            v-model="filterValues[headerCol.id]"
            @input="updateFilterValue(headerCol.id, $event.target.value)"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { debounce } from 'lodash'
import TracesSortButton from '@vue-app/components/base/button/TracesSortButton.vue'

export default {
  name: 'TransactionsTableHeader',
  components: { TracesSortButton },
  props: {
    headerCols: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sort: {
        col: null,
        dir: null,
      },
      statusFilter: true,
      filterValues: {},
    }
  },
  computed: {
    hasFilterInputs() {
      return this.headerCols.some((col) =>
        col.additionalClasses.includes('filter-type__input')
      )
    },
  },
  watch: {
    statusFilter(newVal) {
      this.updateFilterValue('status', newVal)
    },
  },
  methods: {
    setSort(sortColumn) {
      this.sort.col = sortColumn
      this.sort.dir = this.sort.dir === 'DESC' ? 'ASC' : 'DESC'
      $emit(this, 'sortChanged', this.sort)
    },

    updateFilterValue(columnId, value) {
      this.filterValues[columnId] = value

      this.debouncedEmitFilterChanged()
    },

    debouncedEmitFilterChanged: debounce(function () {
      $emit(this, 'filterChanged', { ...this.filterValues })
    }, 1000),
  },
  emits: ['sortChanged', 'filterChanged'],
}
</script>

<style lang="scss" scoped>
.transactions-table-header {
  display: grid;
  grid-template-rows: auto auto;
  &__col {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 6px;
    border-bottom: 1px solid transparent;

    &.sort-active &-text {
      color: #64748B;
      font-weight: 600;
    }

    &.sort-active {
      :deep(.sort-button__arrow svg path) {
        stroke: #64748B;
      }
    }

    &-text {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-transform: uppercase;
      color: #909cb0;
      opacity: 0.7;
    }

    &-sort {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
    }
  }

  &__col-input {
    padding: 8px 6px;
    border-top: 1px solid #eff2f8;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;

    input[type='text'] {
      width: 100%;
      padding: 4px 8px;
      height: 38px;
      background: #fafcfe;
      outline: none;
      border: 1px solid #f0f3fa;
      border-radius: 6px;
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 18px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 18px;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #64748B;
  }

  input:checked + .slider:before {
    transform: translateX(16px);
  }

  .status-switch {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 120px;
  }
}
</style>
